import { Controller } from "react-hook-form";
import Icons from "../../assets/icon";
import Functions from "./index.function";

const Dropdown = ({
  control,
  name,
  options = [],
  handleSelect,
  label,
  iconStyle,
  icon,
  valueoption,
  valueName,
  rightIcon,
  isLoading,
  errors,
  isMandatory,
  isRequired,
}) => {
  const {
    dropdownRef,
    isOpen,
    toggleDropdown,
    searchTerm,
    setSearchTerm,
    filteredOptions,
    setIsOpen,
  } = Functions(options, valueName);
  
  return (
    <div className="relative w-full lg:pt-1" ref={dropdownRef}>
      <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center">
        <label
          htmlFor={name}
          className="xs:text-sm sm:text-base font-onestRegular text-secondary"
        >
          {label}
        </label>
        <p className="text-errorRed pl-1 text-lg leading-3">
          {isMandatory ? "*" : ""}
        </p>
      </div>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        rules={isRequired ? {} : { required: `${label} is required` }}
        render={({ field }) => {
          // Find the selected option with type-safe comparison
          const selectedOption = options.find(
            (option) => 
              option[valueoption] === field.value || 
              String(option[valueoption]) === String(field.value)
          );
          
          // Debug logs
          
          return (
            <>
              <div
                className={`relative xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-3.5 rounded-full text-[#808080] transition duration-300 delay-100 border-2 ${
                  isOpen ? "border-goldMetallic" : "border-transparent"
                } ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                onClick={() => !isLoading && toggleDropdown()}
              >
                <div className="flex items-center justify-between">
                  <input
                    type="text"
                    value={
                      isOpen
                        ? searchTerm
                        : selectedOption?.[valueName] || ""
                    }
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder={`Search ${label}`}
                    className="w-full bg-transparent outline-none text-[#ccc] placeholder-[#808080] px-1"
                    readOnly={!isOpen}
                  />
                  {icon && (
                    <img
                      className={`absolute left-5 3xl:left-8 top-1/2 transform -translate-y-1/2 ${iconStyle}`}
                      src={icon}
                      alt={`${name} icon`}
                    />
                  )}
                  <img
                    className="absolute right-5 3xl:top-[30%] xs:top-4 sm:top-4 top-5 3xl:right-8 transform -translate-y-1/2 xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-5 w-6 3xl:w-7 3xl:h-6 transition-transform duration-500"
                    src={Icons.arrowIcon}
                    alt="Dropdown icon"
                    style={{
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </div>
              </div>
              {isOpen && (
                <div className="absolute z-10 w-full bg-[#171717] rounded-3xl mt-2 max-h-60 overflow-y-auto scroll-container shadow-lg border-goldMetallic border-2">
                  <ul className="text-[#808080] max-h-48 overflow-y-auto dashboard-scrollbar pr-1">
                    {filteredOptions.length > 0 ? (
                      filteredOptions.map((option, index) => (
                        <li
                          key={option.id || index}
                          onClick={() => {
                            const value = String(option[valueoption]);
                            field.onChange(value);
                            handleSelect(value);
                            setIsOpen(false);
                            setSearchTerm("");
                          }}
                          className={`py-3 relative xs:text-sm sm:text-base cursor-pointer transition duration-300 px-4 ${
                            index !== filteredOptions.length - 1
                              ? "after:absolute after:bottom-0 after:left-4 after:w-11/12 after:h-[2px] after:bg-[#212121]"
                              : ""
                          }`}
                        >
                          {option[valueName]}
                        </li>
                      ))
                    ) : (
                      <li className="py-3 px-4 text-center text-[#555]">
                        No results found
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </>
          );
        }}
      />
      <div className="flex justify-start items-center xs:pl-6 sm:pl-6 lg:pl-8 xs:pt-[2px] sm:pt-1">
        {errors?.[name]?.type === "required" && (
          <span className="text-orangeCrayola font-onestRegular xs:text-xs sm:text-sm">
            {errors?.[name].message}
          </span>
        )}
      </div>
    </div>
  );
};

export default Dropdown;